import React from 'react';
import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Paper,
} from '@mui/material';

const AvatarFilters = ({ filters, onFilterChange, accents = [] }) => {
  const handleChange = (field, value) => {
    onFilterChange({ ...filters, [field]: value });
  };

  const formControlSX = {
    minWidth: 180,
    flex: 1,
    '& .MuiOutlinedInput-root': {
      borderRadius: '999px',
      backgroundColor: 'background.paper',
      '& fieldset': {
        borderColor: '#db2777',
      },
      '&:hover fieldset': {
        borderColor: '#be185d',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#be185d',
        borderWidth: 1.5,
      },
    },
  };

  const accentOptions = [
    '',
    'American',
    'Brazilian',
    'British',
    'Central European',
    'Chinese',
    'Eastern European',
    'French',
    'German',
    'Indian',
    'Irish',
    'Israeli',
    'Italian',
    'Japanese',
    'Latin American',
    'Middle Eastern',
    'South African',
  ];

  return (
    <Paper
      elevation={0}
      sx={{
        p: 1,
        mb: 3,
        borderRadius: 3,
        backgroundColor: 'transparent',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: 1,
        }}
      >
        <FormControl fullWidth size="small" sx={formControlSX}>
          <InputLabel>All Styles</InputLabel>
          <Select
            value={filters.style || 'all'}
            label="All Styles"
            onChange={(e) => handleChange('style', e.target.value)}
          >
            <MenuItem value="all">All Styles</MenuItem>
            <MenuItem value="realistic">Realistic</MenuItem>
            <MenuItem value="animated">Animated</MenuItem>
          </Select>
        </FormControl>

        <FormControl fullWidth size="small" sx={formControlSX}>
          <InputLabel>All Genders</InputLabel>
          <Select
            value={filters.gender || ''}
            label="All Genders"
            onChange={(e) => handleChange('gender', e.target.value)}
          >
            <MenuItem value="">All Genders</MenuItem>
            <MenuItem value="male">Male</MenuItem>
            <MenuItem value="female">Female</MenuItem>
          </Select>
        </FormControl>

        <FormControl fullWidth size="small" sx={formControlSX}>
          <InputLabel>All Accents</InputLabel>
          <Select
            className="avpg-filter-sel"
            value={filters.accent || ''}
            label="All Accents"
            onChange={(e) => handleChange('accent', e.target.value)}
          >
            {accentOptions.map((accent) => (
              <MenuItem key={accent} value={accent}>
                {accent || 'All Accents'}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
    </Paper>
  );
};

export default AvatarFilters;
